import { isObj } from "ramda-adjunct";
import { CreationTypeEnum } from "./BuildingSpecificationForm";

export type BuildingSpecParameter = {
  name: string;
  value: string;
  type: string;
};

type Props = {
  creationType: number;
  parameters: BuildingSpecParameter[];
};

export const ParametersTable: React.FC<Props> = ({
  creationType,
  parameters,
}) => (
  <table className="rooms-table">
    <tr>
      <th className="w-40">Name</th>
      <th className="w-40">Value</th>
      <th className="w-20">IsRandom</th>
    </tr>
    {parameters.map((parameter: any, index: number) => (
      <tr key={index}>
        <td>{parameter.name}</td>
        <td>
          {isObj(parameter.value) ? parameter.value.result : parameter.value}
        </td>
        <td>
          <div className="col-12 d-flex justify-content-center">
            {creationType === CreationTypeEnum.RANDOM ? (
              <img
                src={"/Random.svg"}
                alt={"success Shuffle"}
                className={"ebd-shuffle-btn"}
              />
            ) : (
              <img
                src={"/Not_Random.svg"}
                alt={"success Shuffle"}
                className={"ebd-shuffle-btn"}
              />
            )}
          </div>
        </td>
      </tr>
    ))}
  </table>
);
